import { useEffect, useState } from 'react';

const DEFAULT_REFRESH_INTERVAL = 30 * 1000; // 30 seconds

/**
 * {@link useTime} allows avoiding reading the current time within the react rendering process.
 * This avoids impure components that get in the way of react caching renders.
 * <https://react.dev/reference/rules/components-and-hooks-must-be-pure#components-and-hooks-must-be-idempotent>
 */
export function useTime(refreshInterval = DEFAULT_REFRESH_INTERVAL) {
  const [time, setTime] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(Date.now());
    }, refreshInterval);

    return () => clearInterval(interval);
  }, [refreshInterval]);

  return time;
}
